const CONVERTABLE_QUOTES = [
  'ETH-0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH
  'POLYGON-0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', // WMATIC
  'ETH-0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', // WBTC
  'BSC-0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', // WBNB
  'BSC-0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82', // Cake
  'ELROND-WEGLD-bd4d79', // WEGLD
  'AVAX-0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', // WAVAX
  'FTM-0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83', // WFTM
  'BASE-0x4200000000000000000000000000000000000006', // WETH-BASE
  'OPTIMISM-0x4200000000000000000000000000000000000006', // WETH-OP
  'OKX-0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15', // WOKT-OKX
  'BSC-0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', // BSC-BTCB
  'ARBITRUM-0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', // WETH
  'TRON-TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR', // TRX
  'CRONOS-0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23', // WCRO
  'ZKSYNC-0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91', // WETH
];
const CONV_SYMBOL = 'USD@';
const TESTNET_IDENTIFIER = 'testnet';
const TESTNET_SYMBOl = '@TESTNET';

const pairConvertable = (chain: string, quoteAddress: string): boolean => {
  const key = `${chain}-${quoteAddress}`;
  return CONVERTABLE_QUOTES.includes(key);
};

const convertSymbol = (pair: string, flipped: boolean): string => {
  let quote;
  if (flipped) {
    [quote] = pair.split('/');
  } else {
    [, quote] = pair.split('/');
  }

  return quote;
};

const getConvSymbol = (sym: string) => sym.split(CONV_SYMBOL)[1];

const filterSymbolFromConv = (sym: string) => sym.split(CONV_SYMBOL).join('');

const convertTestnetSymbol = (chain: string, sym: string): string =>
  chain.toLowerCase().includes(TESTNET_IDENTIFIER) ? sym + TESTNET_SYMBOl : sym;

const hasTestnetSymbol = (sym: string): boolean => sym.includes(TESTNET_SYMBOl);

const filterSymbolFromTestnet = (sym: string) =>
  sym.split(TESTNET_SYMBOl).join('');

export {
  CONVERTABLE_QUOTES,
  CONV_SYMBOL,
  convertSymbol,
  filterSymbolFromConv,
  getConvSymbol,
  pairConvertable,
  convertTestnetSymbol,
  hasTestnetSymbol,
  filterSymbolFromTestnet,
};
